import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../common/services/api.service';
import { environment } from '../../../environments/environment';

interface LoginResponse {
    Status: number;
    HasError: boolean;
    ErrorList: string[];
    Result: {
        LoginResultStatus: number;
        LoginResultStatusDescription: string;
        NumeroCredencial: string;
        DocumentoNumero: string;
        AccessToken: string;
        RefreshToken: string;
    };
}

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private loginUrl = `${environment.api.url}${environment.api.auth.login}`;

    constructor(private api: ApiService) { }

    login(credencial: string, documento: string): Observable<LoginResponse> {
        const payload = {
            NumeroCredencial: credencial,
            DocumentoNumero: documento
        };
        return this.api.postAbsolute(this.loginUrl, payload);
    }
}
